var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 18C6.99999 14 12.5 7.66667 16 5C19.1667 7 25.5 12.7 25.5 17.5C25.5 23.5 21 28 15 28C10.4723 28 7.00001 22.1231 7 18Z",
    fill: "#3952BF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.66667C8.89331 8.73333 5.33331 13.9733 5.33331 18.4C5.33331 25.04 10.4 29.3333 16 29.3333C21.6 29.3333 26.6666 25.04 26.6666 18.4C26.6666 13.9733 23.1066 8.73333 16 2.66667ZM16 26.6667C11.5333 26.6667 7.99998 23.24 7.99998 18.4C7.99998 15.28 10.6 11.1467 16 6.21333C21.4 11.1467 24 15.2667 24 18.4C24 23.24 20.4666 26.6667 16 26.6667ZM10.44 18.6667C10.9333 18.6667 11.3333 19.0133 11.4266 19.4933C11.9733 22.4533 14.4666 23.4667 16.28 23.32C16.8533 23.2933 17.3333 23.7467 17.3333 24.32C17.3333 24.8533 16.9066 25.2933 16.3733 25.32C13.5333 25.4933 10.2133 23.8667 9.45331 19.8267C9.43014 19.6837 9.4383 19.5374 9.47721 19.3979C9.51613 19.2584 9.58488 19.1291 9.67871 19.0188C9.77253 18.9085 9.8892 18.8198 10.0206 18.759C10.1521 18.6982 10.2952 18.6667 10.44 18.6667Z",
    fill: "#3952BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidity);
export default __webpack_public_path__ + "static/media/humidity.4899b7a126b6aa9e7d7045284e5c0514.svg";
export { ForwardRef as ReactComponent };